import { actionCreator } from '../../utils/actions';

export const changeCurrentRange = actionCreator('Dashboard/CHANGE_CURRENT_RANGE');
export const filterByMonth = actionCreator('Dashboard/FILTER_BY_MONTH');



// WEBPACK FOOTER //
// ./src/components/Dashboard/actions.js